import { Link, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import {
  Dialog,
  DialogHeader,
  Typography,
  IconButton,
  DialogBody,
  Button,
} from '@material-tailwind/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useEffect, useMemo, useState } from 'react';
import ListaLocaisApc from '../../components/Listas/ListaLocaisApc';
import { getProdutoInEquipamento } from '../../slices/productSlice';
import ModalImg from '../../components/Modal/ModalImg';
import ListInfo, { colorApclition } from './ListInfo';
import { Pencil } from 'lucide-react';
import { LinearProgress } from '@mui/material';

const Produto = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const { productos, inequip, role, loading } = useSelector((state) => state.product);

  const { id } = useParams();
  const [produto, setProduto] = useState(null);

  const onProduct = () => {
    const produto = productos.filter((produto) => produto.winthor === id);
    return produto;
  };

  useEffect(() => {
    if (id) {
      dispatch(getProdutoInEquipamento(id));
    }
  }, [id]);

  useEffect(() => {
    const produto = onProduct();
    setProduto(produto[0]);
  }, [id, productos]);

  useEffect(() => {
    if (produto) {
      document.title = `Estoque | ${produto?.nome}`;
    }
  }, [produto]);

  const handleNavigate = () => {
    navigate('/');
  };

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleNavigateEdit = () => {
    navigate('/cadastrar/produto/?edit', { state: { produto } });
  };

  return (
    <>
      <Dialog
        open={true}
        handler={handleNavigate}
        size="lg"
        className={`p-0  bg-gray-400 dark:bg-none  dark:bg-darkColorBg max-h-[90vh] overflow-auto  global-scrollbar min-h-[80vh]`}
      >
        <DialogHeader className="relative m-0 block overflow-hidden bg-lightMenu dark:bg-black/20">
          <Typography variant="h4" className="dark:text-darkText text-white">
            {produto?.nome}
          </Typography>
          <Typography
            variant="h6"
            className="dark:text-darkText text-white uppercase font-light mt-2 "
          >
            {produto?.descricao}
          </Typography>
          <Link to={`/cadastrar/produto/editar/${produto?.winthor}`}>
            <Pencil
              size={20}
              color="red"
              className=" md:!absolute right-16 top-4 cursor-pointer "
            />
          </Link>
          <IconButton
            size="sm"
            variant="text"
            color="white"
            className="!absolute right-3.5 top-3.5"
            onClick={handleNavigate}
          >
            <XMarkIcon className="h-5 w-5 stroke-2 text-white dark:text-darkText " />
          </IconButton>
        </DialogHeader>
        {loading && <LinearProgress />}
        {!loading && (
          <DialogBody className="">
            <div className="w-full sm:flex gap-2 ">
              <div className="basis-[40%] flex flex-col lg:justify-center lg:items-center gap-y-2">
                <div className="w-full">
                  <img
                    src={produto?.foto || '/img/not-img.png'}
                    className="object-contain w-full max-h-[300px] "
                    alt=""
                    onClick={handleOpen}
                  />
                </div>
                {produto?.lastPreco && (
                  <div
                    className={`${
                      produto?.tipoEstoque ? colorApclition(produto.tipoEstoque) : ''
                    } flex flex-col items-center p-3 rounded-[15px] w-[80%] justify-center`}
                  >
                    <Typography variant="h1" color="white">
                      {produto?.lastPreco ? `R$ ${produto.lastPreco}` : '--------'}
                    </Typography>
                    <Button variant="outlined" className="bg-white/20 ">
                      {produto?.tipoEstoque}
                    </Button>
                  </div>
                )}
              </div>
              <div className="flex  basis-[60%]">
                <ListInfo produto={produto} />
              </div>
            </div>
            <div className="w-full flex justify-between sm:justify-end sm:items-end gap-5 bottom-0 right-4 text-black mt-2">
              {produto?.ultima_entrada && (
                <Link to={`/historico/entradas/?historico=${id}`}>
                  <Button
                    className="font-bold italic dark:text-cyan-200   hover:text-green-300 "
                    color="green"
                  >
                    Historico de entrada
                  </Button>
                </Link>
              )}
              {produto?.ultima_saida && (
                <Link to={`/historico/saida/?historico=${id}`}>
                  <Button
                    className="font-bold italic  dark:text-cyan-200   hover:text-green-300 bg-red-500 "
                    variant="gradient"
                    color="red"
                  >
                    Historico de saida
                  </Button>
                </Link>
              )}
            </div>
            <div>
              <div>
                <Typography
                  variant="h5"
                  className="text-center pb-1 italic text-black dark:text-white "
                >
                  Locais de aplicaçao
                </Typography>
                <div className="overflow-auto ">
                  <ListaLocaisApc item={inequip} />
                </div>
              </div>
            </div>
            <ModalImg foto={produto?.foto} open={open} handleOpen={handleOpen} />
          </DialogBody>
        )}
      </Dialog>
    </>
  );
};

export default Produto;
